import { CustomerModel, type CustomerModelCloudConnectModel } from "@doitintl/cmp-models";
import { getCollection, type ModelIdRef } from "@doitintl/models-any";
import { useCollectionData } from "@doitintl/models-hooks";

import { type Customer } from "../../types";

export function useCloudConnect(
  customer: Customer | undefined | null
): [ModelIdRef<CustomerModelCloudConnectModel>[], boolean] {
  const [cloudConnect, loading] = useCollectionData<CustomerModelCloudConnectModel, "id", "ref">(
    customer ? getCollection(CustomerModel).doc(customer.id).collection("cloudConnect") : undefined,
    {
      idField: "id",
      refField: "ref",
    }
  );

  return [cloudConnect ?? [], loading];
}
